/* eslint-disable react-hooks/exhaustive-deps */

import React, { ReactElement, useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import TextAdmin from '../../../../../components/Admin/inputs/paragraph'
import Button from '../../../../../components/button'
import {
  StyledAdminPart,
  AddSection,
  CardPart,
  StyledIcons,
  CardsPart,
} from './styled-components'

import { StyledIcon } from '../../../styled-components'
import ImageAdmin from '../../../../../components/Admin/inputs/image'
import ImageTextAdmin from '../../../../../components/Admin/inputs/image-paragraph'
import TwoTextAdmin from '../../../../../components/Admin/inputs/two-paragraph'
import ImageCard from '../../../../../assets/images/image.png'
import TextCard from '../../../../../assets/images/text.png'
import ImageTextCard from '../../../../../assets/images/image-text.png'
import TextImageCard from '../../../../../assets/images/text-image.png'
import TwoTextCard from '../../../../../assets/images/two-text.png'
import VideoCard from '../../../../../assets/images/video.png'
import Icon from '../../../../../components/icon'
import { useAddTextAdminContext } from '../../../../../contexts/add-text-admin'
import {
  Category,
  Part,
  Training,
  TrainingGroup,
} from '../../../../../types/training'
import { updateTextPart } from '../../../../../api/part'
import { Alert } from '../../../../../constants/sweet-alert'
import AdminTemplate from '../../../../base-template'
import Preview from './preview'
import VideoAdmin from '../../../inputs/video'
import TextImageAdmin from '../../../inputs/text-image'

interface AdminPartTextProps {
  trainingsGroup: TrainingGroup
  training: Training
  category: Category | undefined
  part: Part | undefined
}

const AdminPartText = ({
  trainingsGroup,
  training,
  category,
  part,
}: AdminPartTextProps): ReactElement => {
  const { addTextAdmin, setAddTextAdmin } = useAddTextAdminContext()
  const [loading, setLoading] = useState(false)

  const [showAdd, setShowAdd] = useState(false)
  const [preview, setPreview] = useState(false)

  useEffect(() => {
    if (part?.text) {
      setAddTextAdmin(JSON.parse(part?.text))
    } else {
      setAddTextAdmin([])
    }
  }, [])

  const addSection = (type: string) => {
    const oldSections = [...addTextAdmin]

    oldSections.push({
      id: addTextAdmin.length,
      type,
      value: '',
    })

    setAddTextAdmin(oldSections)

    setShowAdd(false)
    setTimeout(
      () =>
        window.scrollTo({
          top: document.documentElement.scrollHeight,
          behavior: 'smooth',
        }),
      0
    )
  }

  const navigate = useNavigate()

  const onSave = () => {
    setLoading(true)
    if (part) {
      const payload = {
        text: JSON.stringify(addTextAdmin),
      }
      updateTextPart(part.id, payload).then((status) => {
        if (status === 200) {
          setLoading(false)
          Alert.fire({
            icon: 'success',
            title: `Updated`,
          })
          navigate(0)
        } else {
          setLoading(false)
          Alert.fire({
            icon: 'error',
            title: `Error`,
          })
        }
      })
    }
  }

  const deleteSection = (idSection: number) => {
    const oldSections = [...addTextAdmin]
    const findSection = oldSections.findIndex((e) => e.id === idSection)
    oldSections.splice(findSection, 1)
    setAddTextAdmin(oldSections)
  }

  if (category && part) {
    return (
      <>
        <AddSection showAdd={showAdd}>
          <StyledIcon onClick={() => setShowAdd(false)}>
            <Icon name={'cil:x'} color="darkRed" width={20} height={20} />
          </StyledIcon>
          <CardsPart>
            <CardPart
              onClick={() => {
                addSection('text')
              }}
              src={TextCard}
            />
            <CardPart onClick={() => addSection('image')} src={ImageCard} />
            <CardPart
              onClick={() => addSection('image-text')}
              src={ImageTextCard}
            />
            <CardPart
              onClick={() => addSection('text-image')}
              src={TextImageCard}
            />
            <CardPart
              onClick={() => addSection('two-text')}
              src={TwoTextCard}
            />
            <CardPart onClick={() => addSection('video')} src={VideoCard} />
          </CardsPart>
        </AddSection>
        <AdminTemplate
          childrenBar={
            <StyledIcons>
              <Button onClick={() => setPreview(!preview)} color="red">
                <Icon
                  name={
                    preview
                      ? 'icon-park-outline:preview-close-one'
                      : 'icon-park-outline:preview-open'
                  }
                />
              </Button>
              <Button loading={loading} onClick={onSave} color="red">
                <Icon name="entypo:check" />
              </Button>
            </StyledIcons>
          }
          adminTemplate
          navigation={[
            {
              title: trainingsGroup.title,
              link: `/trainings?type=${trainingsGroup.name}`,
            },
            {
              title: training.title,
              link: `/trainings?type=${trainingsGroup.name}&training_id=${training.id}`,
            },
            {
              title: category.title,
              link: `/trainings?type=${trainingsGroup.name}&training_id=${training.id}&category_id=${category.id}`,
            },
            {
              title: part.title,
              link: `/trainings?type=${trainingsGroup.name}&training_id=${training.id}&category_id=${category.id}&part_id=${part.id}`,
            },
          ]}
          onAddClick={() => setShowAdd(true)}
          showAdd={showAdd}
        >
          <StyledAdminPart>
            {preview ? (
              <Preview />
            ) : (
              <>
                {addTextAdmin?.map((section, index) => (
                  <div key={index}>
                    {section.type === 'text' ? (
                      <TextAdmin
                        key={section.id}
                        id={section.id}
                        value={section.value}
                        onDeleteClick={() => deleteSection(section.id)}
                      />
                    ) : section.type === 'image' ? (
                      <ImageAdmin
                        key={section.id}
                        id={section.id}
                        value={section.value}
                        onDeleteClick={() => deleteSection(section.id)}
                      />
                    ) : section.type === 'image-text' ? (
                      <ImageTextAdmin
                        id={section.id}
                        key={section.id}
                        value={section.value}
                        onDeleteClick={() => deleteSection(section.id)}
                      />
                    ) : section.type === 'two-text' ? (
                      <TwoTextAdmin
                        key={section.id}
                        id={section.id}
                        value={section.value}
                        onDeleteClick={() => deleteSection(section.id)}
                      />
                    ) : section.type === 'video' ? (
                      <VideoAdmin
                        key={section.id}
                        id={section.id}
                        value={section.value}
                        onDeleteClick={() => deleteSection(section.id)}
                      />
                    ) : section.type === 'text-image' ? (
                      <TextImageAdmin
                        key={section.id}
                        id={section.id}
                        value={section.value}
                        onDeleteClick={() => deleteSection(section.id)}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                ))}
              </>
            )}
          </StyledAdminPart>
        </AdminTemplate>
      </>
    )
  }
  return <></>
}

export default AdminPartText
